<div class="alert-container">
  <div *ngFor="let alert of alerts; let i = index">
    <ngb-alert [title]="getAlertTitle(alert)" [type]="getAlertType(alert)" (close)="close(i)"><div [innerHTML]="alert.message"></div></ngb-alert>
  </div>
</div>
